import { Flex, View } from "@adobe/react-spectrum";
import { useSelector } from "react-redux";
import CaseSidebar from "./CaseSidebar";
import { RootState } from "../../../store/storeConfig";
import NoActiveCase from "../CaseInformationContainer/NoActiveCase";
import CaseInformationContainer from "../CaseInformationContainer/CaseInformationContainer";
import AcceptDialog from "../../common/AcceptDialog/AcceptDialog";

const CaseComponent = () => {
  const cases = useSelector((state: RootState) => state.cases);
  return (
    <>
      <Flex height={"100%"} width={"100%"}>
        {cases.cases.length > 0 ? (
          <>
            <View backgroundColor="static-white" width={"22%"}>
              <CaseSidebar />
            </View>
            <View backgroundColor="static-white" width={"78%"}>
              <CaseInformationContainer />
            </View>
            {/* <View
              borderColor="gray-300"
              borderWidth="thin"
              backgroundColor="static-white"
              borderTopWidth={NONE}
              width={"25%"}
            >
              <CaseAi caseID="" />
            </View> */}
          </>
        ) : (
          <NoActiveCase isCaseTab={true} />
        )}
        <AcceptDialog type="case" />
      </Flex>
    </>
  );
};

export default CaseComponent;
